import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'runtime'
export const pluginName = 'hawtio-runtime'
export const pluginPath = '/runtime'
export const log = Logger.get(pluginName)
